import client from './client';

// Tenant-wide media feed for FPA members.
// params: { page, page_size, media_type: 'all'|'image'|'video', tenant_id? }
export const getGallery = (params) =>
  client.get('/gallery', { params }).then((r) => r.data);
